/**
 * @fileoverview added by tsickle
 * Generated from: util/datetime/duration.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { floor, round } from 'lodash-es';
import * as moment from 'moment';
/**
 * @record
 */
function DurationUnits() { }
if (false) {
    /** @type {?|undefined} */
    DurationUnits.prototype.milliseconds;
    /** @type {?|undefined} */
    DurationUnits.prototype.seconds;
    /** @type {?|undefined} */
    DurationUnits.prototype.minutes;
    /** @type {?|undefined} */
    DurationUnits.prototype.hours;
    /** @type {?|undefined} */
    DurationUnits.prototype.days;
}
/** @type {?} */
var MS_RATIO = {
    milliseconds: 1,
    seconds: 1000,
    minutes: 1000 * 60,
    hours: 1000 * 60 * 60,
    days: 1000 * 60 * 60 * 24
};
/**
 * Represent a span of time
 */
var /**
 * Represent a span of time
 */
Duration = /** @class */ (function () {
    function Duration(_units) {
        var _this = this;
        if (_units === void 0) { _units = {}; }
        this._units = _units;
        this._durationMs = 0;
        Object.keys(_units).forEach((/**
         * @param {?} unit
         * @return {?}
         */
        function (unit) {
            _this._durationMs += _units[unit] * MS_RATIO[unit];
        }));
    }
    /**
     * @return {?}
     */
    Duration.prototype.toMilliseconds = /**
     * @return {?}
     */
    function () {
        return this._durationMs;
    };
    /**
     * @param {?=} precision
     * @return {?}
     */
    Duration.prototype.toSeconds = /**
     * @param {?=} precision
     * @return {?}
     */
    function (precision) {
        if (precision === void 0) { precision = 2; }
        return round(this._durationMs / MS_RATIO.seconds, precision);
    };
    /**
     * @param {?=} precision
     * @return {?}
     */
    Duration.prototype.toMinutes = /**
     * @param {?=} precision
     * @return {?}
     */
    function (precision) {
        if (precision === void 0) { precision = 2; }
        return round(this._durationMs / MS_RATIO.minutes, precision);
    };
    /**
     * @param {?=} precision
     * @return {?}
     */
    Duration.prototype.toMinutesFloor = /**
     * @param {?=} precision
     * @return {?}
     */
    function (precision) {
        if (precision === void 0) { precision = 2; }
        return floor(this._durationMs / MS_RATIO.minutes, precision);
    };
    /**
     * @param {?=} precision
     * @return {?}
     */
    Duration.prototype.toHours = /**
     * @param {?=} precision
     * @return {?}
     */
    function (precision) {
        if (precision === void 0) { precision = 2; }
        return round(this._durationMs / MS_RATIO.hours, precision);
    };
    /**
     * @param {?=} precision
     * @return {?}
     */
    Duration.prototype.toHoursFloor = /**
     * @param {?=} precision
     * @return {?}
     */
    function (precision) {
        if (precision === void 0) { precision = 2; }
        return floor(this._durationMs / MS_RATIO.hours, precision);
    };
    /**
     * @param {?=} precision
     * @return {?}
     */
    Duration.prototype.toDays = /**
     * @param {?=} precision
     * @return {?}
     */
    function (precision) {
        if (precision === void 0) { precision = 2; }
        return round(this._durationMs / MS_RATIO.days, precision);
    };
    /**
     * @param {?=} precision
     * @return {?}
     */
    Duration.prototype.toDaysFloor = /**
     * @param {?=} precision
     * @return {?}
     */
    function (precision) {
        if (precision === void 0) { precision = 2; }
        return floor(this._durationMs / MS_RATIO.days, precision);
    };
    /**
     * @param {?} other
     * @return {?}
     */
    Duration.prototype.add = /**
     * @param {?} other
     * @return {?}
     */
    function (other) {
        return new Duration({
            milliseconds: this.toMilliseconds() + other.toMilliseconds()
        });
    };
    /**
     * @param {?} other
     * @return {?}
     */
    Duration.prototype.subtract = /**
     * @param {?} other
     * @return {?}
     */
    function (other) {
        return new Duration({
            milliseconds: this.toMilliseconds() - other.toMilliseconds()
        });
    };
    /**
     * @param {?} formatStr
     * @return {?}
     */
    Duration.prototype.format = /**
     * @param {?} formatStr
     * @return {?}
     */
    function (formatStr) {
        return moment.utc(this.toMilliseconds()).format(formatStr);
    };
    return Duration;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    Duration.prototype._durationMs;
    /**
     * @type {?}
     * @private
     */
    Duration.prototype._units;
}
/**
 * @param {?} existingOutput
 * @param {?} n
 * @param {?} partName
 * @return {?}
 */
function appendHumanReadablePart(existingOutput, n, partName) {
    /** @type {?} */
    var output = existingOutput + " " + n + " " + partName;
    if (n > 1) {
        output = output + "s";
    }
    return output;
}
/**
 * @param {?} duration
 * @return {?}
 */
function humanReadableDurationString(duration) {
    /** @type {?} */
    var output = '';
    /** @type {?} */
    var days = duration.toDaysFloor(0);
    if (days >= 1) {
        output = appendHumanReadablePart(output, days, 'day');
        duration = duration.subtract(new Duration({ days: days }));
    }
    /** @type {?} */
    var hours = duration.toHoursFloor(0);
    if (hours >= 1) {
        output = appendHumanReadablePart(output, hours, 'hour');
        duration = duration.subtract(new Duration({ hours: hours }));
    }
    /** @type {?} */
    var minutes = duration.toMinutesFloor(0);
    if (minutes >= 1) {
        output = appendHumanReadablePart(output, minutes, 'minute');
    }
    return output;
}
export { Duration, humanReadableDurationString };
